import { render, staticRenderFns } from "./ShareFileRequest.vue?vue&type=template&id=087a9ba8&scoped=true&"
import script from "./ShareFileRequest.vue?vue&type=script&lang=js&"
export * from "./ShareFileRequest.vue?vue&type=script&lang=js&"
import style0 from "./ShareFileRequest.vue?vue&type=style&index=0&id=087a9ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a9ba8",
  null
  
)

export default component.exports